import React from "react";
import LoginFrame from "./LoginFrame";
import LoginForm from "./LoginForm";
import { Switch, Route, Link } from "react-router-dom";

import config from "../../config";
import { ClientSelect } from "./ClientSelect";
import { Callback } from "./Callback";
import { Redirect } from "./Redirect";
const { loginRoot } = config;

const Login = () => {
  return (
    <React.Fragment>
      <Switch>
        <Route>
          <LoginFrame>
            <Switch>
              <Route exact path={loginRoot}>
                <LoginForm />
              </Route>
              <Route exact path={`${loginRoot}/callback`} >
                <Callback />
              </Route>
              <Route exact path={`${loginRoot}/select-client`}>
                <ClientSelect />
              </Route>
              <Route exact path={`${loginRoot}/redirect`}>
                <Redirect />
              </Route>
              <Route path={loginRoot}>
                <h2>
                  <Link to={loginRoot}>
                    Page not found. Click here to start over.
                  </Link>
                </h2>
              </Route>
              <Route>
                <h2>
                  <a href="/">
                    Page not found. Click here to return to Vanco Food.
                  </a>
                </h2>
              </Route>
            </Switch>
          </LoginFrame>
        </Route>
      </Switch>
    </React.Fragment>
  );
};

export default Login;
